import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "title", "width", "height", "isInformative"];
import React from 'react';
import styled, { css } from 'styled-components';
import StyledContainer from '../Styled/StyledContainer';
import { highContrast } from '../../styling';
import { IS_DEV } from '../../constants';
/**
 * Add this class to parts of svg that should not be changing color.
 */

export var NO_TRANSITION_CLASSNAME = 'no-transition';
var Container = /*#__PURE__*/styled(StyledContainer).withConfig({
  displayName: "Svg__Container",
  componentId: "sc-5yy1y0-0"
})(["", ";", ";", ""], function (_ref) {
  var $width = _ref.$width;
  return $width && css(["width:", "", ";"], $width, typeof $width === 'number' && 'px');
}, function (_ref2) {
  var $height = _ref2.$height;
  return $height && css(["height:", "", ";"], $height, typeof $height === 'number' && 'px');
}, highContrast(css(["*[fill]:not(.", "){fill:CanvasText !important;}*[stroke]:not(.", "){stroke:CanvasText !important;}"], NO_TRANSITION_CLASSNAME, NO_TRANSITION_CLASSNAME)));

/**
 * Width or height (width probably always makes more sense) should be passed in as default.
 * View any svg component for example.
 */
var Svg = function Svg(_ref3) {
  var children = _ref3.children,
      title = _ref3.title,
      width = _ref3.width,
      height = _ref3.height,
      _ref3$isInformative = _ref3.isInformative,
      isInformative = _ref3$isInformative === void 0 ? false : _ref3$isInformative,
      rest = _objectWithoutProperties(_ref3, _excluded);

  if (IS_DEV && isInformative && !title) console.error("Informative SVGs require title for accessibility.");
  return /*#__PURE__*/React.createElement(Container, _extends({
    as: "svg",
    role: isInformative ? 'img' : 'presentation',
    $width: width,
    $height: height
  }, rest), isInformative && /*#__PURE__*/React.createElement("title", null, title), children);
};

export default Svg;